module.exports = __webpack_public_path__ + "img/20210127_150500.72a34461.jpg";